import { useQuery } from '@apollo/client';
import React from 'react';
import { LoadingSpinner } from '../../../../components/Loaders';
import { GET_ALLOWED_DOMAIN_SETTING } from '../../../../utils/apollo/globalConfig/queries';
import {
  IGetAllowedDomainSettingQuery,
  IGetAllowedDomainSettingQueryVariables,
} from '../../../../utils/apollo/graphqlSchema';
import * as SettingsUI from '../SettingsUI';
import AllowedDomainSettingForm from './AllowedDomainSettingForm';
import ConnectedDomains from './ConnectedDomains';

const AllowedDomainSettings = () => {
  const { data, loading, refetch } = useQuery<
    IGetAllowedDomainSettingQuery,
    IGetAllowedDomainSettingQueryVariables
  >(GET_ALLOWED_DOMAIN_SETTING);

  const allowedDomains = data?.allowedDomainSetting?.allowedDomains ?? [];

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <SettingsUI.SettingsSection>
      <SettingsUI.Title>Allowed Domains</SettingsUI.Title>
      <SettingsUI.Description>
        Enter the domains you’d like to allow for third-party embeds.
        <br />
        Please note: It may take a few minutes for newly added domains to become
        active.
      </SettingsUI.Description>
      <AllowedDomainSettingForm
        allowedDomains={allowedDomains}
        refetch={refetch}
      />
      <ConnectedDomains allowedDomains={allowedDomains} refetch={refetch} />
    </SettingsUI.SettingsSection>
  );
};

export default AllowedDomainSettings;
